import React, { createContext, useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import {isTokenExpired, refreshToken} from "../utils/AuthToken";

export const AuthContext = createContext({
  isAuthenticated: false,
  setAuth: () => {},
  loading: true, // Add initial loading state to the context
});

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // Initial state is loading

  useEffect(() => {
    const checkAndRefreshToken = async () => {
        const token = localStorage.getItem("authToken");
        if (token && !isTokenExpired(token)) {
          try {
            const newToken = await refreshToken(token); // Refresh token if the existing one is valid
            setAuthenticated(!!newToken); // Update auth status based on the presence of a new token
          } catch (error) {
            console.error("Failed to refresh token:", error);
            logout(); // Logout if the refresh fails
          }
        } else {
          logout(); // Logout if the token is expired or not present
        }
        setLoading(false); // End loading state
      };
  
      checkAndRefreshToken();
  }, []);

  const logout = () => {
    localStorage.removeItem("authToken"); // Remove the token from local storage
    setAuthenticated(false); // Update state to reflect that user is no longer authenticated
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, setAuth: setAuthenticated, loading, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
